module.exports = __webpack_public_path__ + "media/images/mailers/tik_tok-de1144aebc73c3ee204e464ab75cc5bf.png";